import { defineComponent } from 'vue';
import CloseIcon from 'src/components/icons/close/Close.vue';
import { disableScrollOnModalOpen } from 'src/utils/helper/misc';

export default defineComponent({
    components: {
        CloseIcon
    },
    props: {
        showCrossBtn: {
            type: Boolean,
            default: true
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        showContent: {
            type: Boolean,
            default: true
        },
        showButton1: {
            type: Boolean,
            default: true
        },
        showButton2: {
            type: Boolean,
            default: true
        },
        modalHeading: {
            type: String,
            default: 'Heading'
        },
        modalContent: {
            type: String,
            default: 'Content'
        },
        modalButton1: {
            type: String,
            default: 'Close'
        },
        modalButton2: {
            type: String,
            default: 'Save'
        },
        customBtn1Class: {
            type: Boolean,
            default: false
        }
    },
    emits: ['popup:btn1Click', 'popup:btn2Click', 'popup:crossBtnClick'],
    setup(props, { emit }) {
        const btn1Clicked = () => {
            emit('popup:btn1Click');
            disableScrollOnModalOpen(false);
        };

        const btn2Clicked = () => {
            emit('popup:btn2Click');
            disableScrollOnModalOpen(false);
        };

        const crossBtnClicked = () => {
            emit('popup:crossBtnClick');
            disableScrollOnModalOpen(false);
        };

        return {
            btn1Clicked,
            btn2Clicked,
            crossBtnClicked
        };
    },
    mounted() {
        disableScrollOnModalOpen(true);
    },
    beforeUnmount() {
        disableScrollOnModalOpen(false);
    }
});